import * as yup from "yup";

export const taskDurationSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
  duration: yup.number().required().label("Duration"),
});
